import Vue from "vue";
import Vuex from "vuex";
import 'es6-promise/auto';
import {dependencies} from "@/store";

Vue.use(Vuex);

export default new Vuex.Store(dependencies);

